import { Injectable } from '@angular/core';
import { RegistrationBasketStore } from './registration-basket.store';
import { tap, mapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { Observable, of } from 'rxjs';
import { RegistrationBasketQuery } from './registration-basket.query';
import { RegistrationPurchaseBasket } from './models/registration-purchase-basket';
import { GiftCodeModel } from '../../purchase/models/giftcode/gift-code.model';

@Injectable({ providedIn: 'root' })
export class RegistrationBasketService {

  constructor(private registrationBasketStore: RegistrationBasketStore,
              private registrationBasketQuery: RegistrationBasketQuery,
              private apiService: ApiService) {
  }

  /** Retrieve the current registration's basket to be purchased. */
  public fetchRegistrationBasketForCurrentWizard(appliedGiftCodes: GiftCodeModel[] = []): Observable<null> {

    let queryString = "?";

    appliedGiftCodes.forEach((giftCode) => {
      queryString += `appliedgiftcodeids=${giftCode.Id}`;
      if (appliedGiftCodes.indexOf(giftCode) < appliedGiftCodes.length - 1) {
        queryString += "&";
      }
    });

    const request$ = this.apiService.getAnySingle<RegistrationPurchaseBasket>(`register/basket${appliedGiftCodes.length > 0 ? queryString : ''}`).pipe(
      tap(basket => this.registrationBasketStore.update(basket)),
      mapTo(null)
    );

    return this.registrationBasketQuery.getHasCache() ? of(null) : request$;
  }
}
